// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1awkS","title":"styles_title__3kkR6","subTitle":"styles_subTitle__3J2QB","content":"styles_content__1qWPG"};